import { render } from "./AppStoreIcon.vue?vue&type=template&id=f18f8eaa"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__